import { Breadcrumbs, Link, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeIcon from "@mui/icons-material/Home";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { generateBreadcrumbs, getCurrentPath } from "../../utils/breadcrumbUtils";

const getBreadcrumbLabelKey = label => label;

const BreadcrumbsGenerator = ({
  breadcrumbLinks: manualBreadcrumbLinks,
  customLabels = {}
}) => {
  const {
    t,
    i18n
  } = useTranslation("operations");
  const history = useHistory();
  const location = useLocation();
  const currentLang = i18n.resolvedLanguage;
  const isRtl = i18n.dir() === "rtl" || currentLang?.startsWith("ar");

  // Determine which breadcrumbs to use - manual or auto-generated
  const useManualBreadcrumbs = manualBreadcrumbLinks && manualBreadcrumbLinks.length > 0;

  // Auto-generate breadcrumbs if manual ones aren't provided
  const translateAutoLabel = (label, fallback, config = {}) =>
    t(label, {
      ns: config.namespace || "operations",
      defaultValue: fallback
    });
  const autoBreadcrumbs = !useManualBreadcrumbs ? generateBreadcrumbs(getCurrentPath(location), currentLang, customLabels, {}, translateAutoLabel) : [];

  // Use either manual or auto-generated breadcrumbs
  const breadcrumbLinks = useManualBreadcrumbs ? manualBreadcrumbLinks : autoBreadcrumbs;
  const handleBreadcrumbClick = link => {
    if (link.onClick) {
      link.onClick();
    } else if (link.href) {
      history.push(link.href);
    }
  };
  if (!breadcrumbLinks || breadcrumbLinks.length === 0) {
    return null;
  }
  const breadcrumbLinkSx = {
    color: "#ffffff",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    minHeight: 28,
    lineHeight: 1.25,
    whiteSpace: "nowrap",
    cursor: "pointer",
    border: "none",
    background: "none",
    fontSize: "inherit",
    fontFamily: "inherit",
    "&:hover": {
      textDecoration: "underline"
    }
  };
  const renderLabel = link => {
    const label = link?.label;
    if (typeof label !== "string") return label;
    return t(getBreadcrumbLabelKey(label), {
      ns: link.namespace || "operations",
      defaultValue: label
    });
  };
  return <Breadcrumbs separator={isRtl ? <ChevronLeftIcon fontSize="small" style={{
    color: "#ffffff"
  }} /> : <ChevronRightIcon fontSize="small" style={{
    color: "#ffffff"
  }} />} aria-label={t("breadcrumb")} sx={{
    "& .MuiBreadcrumbs-ol": {
      alignItems: "center"
    }
  }}>
      {/* Always include Home link as first breadcrumb */}
      <Link component="button" variant="body2" onClick={() => handleBreadcrumbClick({
      href: `/${currentLang}/app/main`
    })} sx={breadcrumbLinkSx}>
        <HomeIcon sx={{
        mr: 0.5,
        fontSize: "1.2rem"
      }} />
        {t("Home", "Home")}
      </Link>

      {/* Render custom breadcrumb links */}
      {breadcrumbLinks.map((link, index) => {
      const isLast = index === breadcrumbLinks.length - 1;
      if (isLast) {
        // Last breadcrumb should not be clickable
        return <Typography key={index} color="#ffffff" variant="body2" sx={{
          fontWeight: 500,
          opacity: 0.8
        }}>
              {renderLabel(link)}
            </Typography>;
      }
      return <Link key={index} component="button" variant="body2" onClick={() => handleBreadcrumbClick(link)} sx={breadcrumbLinkSx}>
            {renderLabel(link)}
          </Link>;
    })}
    </Breadcrumbs>;
};
export default BreadcrumbsGenerator;
